module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_vm._v("Timeline")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1862")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battle of Hampton Roads during the American Civil War; first clash between ironclads")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1898")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Loss of USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maine")]), _vm._v(" in Havana, Cuba; beginning of the Spanish-American War")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1904")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battle of the Yellow Sea between Japanese and Russian battle fleets")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1905")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battle of Tsushima between Japanese and Russian battle fleets")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1906")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("British HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreadnought")]), _vm._v(" launched, commencing the era of big-gun battleships and the naval arms race")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1907")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("The Great White Fleet circumnavigates the globe as a display of U.S. naval power")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1914")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battle of the Falkland Islands between British battlecruisers and German cruisers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1916")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battle of Jutland between British and German battle fleets; history’s largest clash of battleships")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1918")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of the Austro-Hungarian SMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Szent István")]), _vm._v(" by an Italian torpedo vessel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1919")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Scuttling of the bulk of the German battle fleet in Scapa Flow")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1921")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of decommissioned battleships in the U.S. by aircraft to demonstrate air power")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1922")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Washington Naval Treaty limited the size and armament of future battle fleets")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Sept. 1939")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("German Pre-Dreadnought "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schleswig-Holstein")]), _vm._v(" fires at the Polish Westerplatte starting World War II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Oct. 1939")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of British HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Royal Oak")]), _vm._v(" by German U-boat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("U-47")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Dec. 1939")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Hunt for the German Panzerschiff "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Graf Spee")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("July 1940")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("British naval attack on French fleet at Mers-el-Kébir")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Nov. 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("British aerial attack on Italian fleet at Taranto")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("May 1941")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battle of the Denmark Strait and the hunt for the German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Dec. 1941")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Japanese Attack on Pearl Harbor")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Dec. 1941")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prince of Wales")]), _vm._v(" and HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Repulse")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Sept. 1943")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of the Italian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roma")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Dec. 1943")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of the German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scharnhorst")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("June 1944")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Allied landings in Normandy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Oct. 1944")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Last battleship-to-battleship clash in Surigao Strait")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Nov. 1944")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of the German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tirpitz")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1944/45")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sinking of the Japanese "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Musashi")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yamato")]), _vm._v(", the largest battleships ever built")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1945")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Japanese surrender aboard the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missouri")]), _vm._v(" ending World War II")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1946")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crossroads;")]), _vm._v(" nuclear weapon tests conducted by the U.S. at Bikini Atoll")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1950")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battleship gunfire support during the Korean War")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1968")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battleship gunfire support during the Vietnam War")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1982")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Comeback”")]), _vm._v(" of the battleship")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1991")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Battleship gunfire support during Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desert Storm")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("1992")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Final decommissioning of the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missouri,")]), _vm._v(" the world’s last active battleship")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7164732c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Timeline.vue
// module id = 72
// module chunks = 0